import PropTypes from 'prop-types'
import { useSearchParams } from 'react-router-dom'
import { FILTER_TYPE } from '../../common/filterCompany/constant'
import { FilterCompanySetting } from '../../common/filterCompany/filterSetting'
import { SideBar } from '../../common/sideBar'
import { COMPONENTS } from '../../routers/constants'
import { Header } from './header'
import './i18n'
import { StickyBar } from './stickyBar'

export const PORTFOLIO_SCROLL_ID = 'PORTFOLIO_SCROLL_ID'

const getTabList = () => {
  return [
    {
      route: COMPONENTS.portfolioInsights.components.summary.route,
      label: 'portfolio.common.SUMMARY',
    },
    {
      route: COMPONENTS.portfolioInsights.components.finance.route,
      label: 'portfolio.common.BY_FINANCE',
    },
    {
      route: COMPONENTS.portfolioInsights.components.score.route,
      label: 'portfolio.common.BY_SCORE',
    },
    {
      route: COMPONENTS.portfolioInsights.components.segment.route,
      label: 'portfolio.common.BY_SEGMENT',
    },
  ]
}

const Layout = ({
  hasCurrencyUnit,
  renderCustomHeader,
  renderLeftBar,
  renderBottom,
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const isSettings = searchParams.get('settings') === 'true'

  const handleBack = () => {
    setSearchParams({})
  }

  const renderTopComponent = () => {
    if (isSettings) return null
    return <Header renderCustomHeader={renderCustomHeader} />
  }

  const renderStickyComponent = () => {
    if (isSettings) return null
    return (
      <StickyBar
        renderLeftBar={renderLeftBar}
        hasCurrencyUnit={hasCurrencyUnit}
      />
    )
  }

  const renderBottomComponent = () => {
    if (isSettings) {
      return (
        <FilterCompanySetting
          filterType={FILTER_TYPE.PORTFOLIO_INSIGHTS}
          buttonBackProps={{
            style: { marginTop: 16 },
            text: 'library.main.BACK_TO_PAGE',
            onClick: () => setSearchParams({}),
          }}
          onSave={handleBack}
          onSaveDefault={handleBack}
        />
      )
    }

    return renderBottom()
  }

  return (
    <>
      <SideBar
        list={getTabList()}
        isShowFooter
        isResponsive={false}
        renderTopComponent={renderTopComponent}
        renderStickyComponent={renderStickyComponent}
        renderBottomComponent={renderBottomComponent}
        scrollId={PORTFOLIO_SCROLL_ID}
        headerStyle={isSettings ? { padding: 0 } : {}}
        contentStyle={isSettings ? { flex: 'none', height: '100%' } : {}}
      />
    </>
  )
}

Layout.propTypes = {
  hasCurrencyUnit: PropTypes.bool,
  renderCustomHeader: PropTypes.func,
  renderLeftBar: PropTypes.func,
  renderBottom: PropTypes.func,
}

Layout.defaultProps = {
  hasCurrencyUnit: false,
  renderCustomHeader: () => {},
  renderLeftBar: () => {},
  renderBottom: () => {},
}

export default Layout
